import { storage, getDownloadURL, ref } from '../../firebase.js';

export async function getImageFirebase(location) {
    const starRef = ref(storage , location);
    const ImageURL = await getDownloadURL(starRef).catch();
    return ImageURL
}